module.exports = __webpack_public_path__ + "img/doremy sweet_lw.0f78ac6d.png";